<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="3" xl="3"></CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <!-- <CCard class="pb-3"> -->
        <CCardHeader class="d-flex justify-content-between">
          <b
            ><span
              ><i class="fas fa-calendar"></i>&nbsp;Cumpleños del mes</span
            ></b
          >
          <button
            @click="returnHome"
            type="button"
            class="btn btn-sm text-white"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Retroceder
          </button>
        </CCardHeader>
        <!-- </CCard> -->
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <div class="scroll-container">
          <span style="text-align: center"
            ><h4><b>LISTA DE CLIENTES</b></h4></span
          >
          <div v-for="(item, index) in client" :key="index" class="card">
            <div class="card-body d-flex align-items-center p-3">
              <div :class="mtdGetCardClass(item.fech_nacimiento)">
                <i class="fas fa-birthday-cake"></i>
              </div>
              <div>
                <div class="text-value text-gradient-warning">
                  <input
                    type="checkbox"
                    v-model="select"
                    :value="item"
                    class="mr-2"
                  />
                  {{ item.name }}
                </div>
                <div class="text-muted text-uppercase font-weight-bold small">
                  {{ formatDate(item.fech_nacimiento) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <div class="scroll-container">
          <span style="text-align: center"
            ><h4><b>CLIENTES SELECCIONADOS</b></h4></span
          >
          <template v-if="select.length > 0">
            <div v-for="(item, index) in select" :key="index" class="card">
              <div class="card-body d-flex align-items-center p-3">
                <div :class="mtdGetCardClass(item.fech_nacimiento)">
                  <i class="fas fa-birthday-cake"></i>
                </div>
                <div>
                  <div class="text-value text-gradient-warning">
                    {{ item.name }}
                  </div>
                  <div class="text-muted text-uppercase font-weight-bold small">
                    {{ formatDate(item.fech_nacimiento) }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="card-body d-flex align-items-center p-3">
            <div class="mr-3 text-white bg-gradient-info p-3 w-100">
              <span>No tiene seleccionados</span>
            </div>
          </div>
        </div>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <span style="text-align: center"
          ><h4><b>MENSAJE PARA ENVIAR</b></h4></span
        >
        <textarea rows="20" :disabled="select.length>0?false:true" placeholder="ESCRIBA UN MENSAJE PARA ENVIAR, PUEDE AÑADIR EMOTICONES." class="form-control form-control-sm" v-model="message"></textarea>
        <span>** Para colocar el nombre del cliente en automatico presione aqui:  <button class="btn btn-sm btn-info" @click="mtdAddNameClientWsp">Añadi nombre de cliente</button></span><br>
        <button @click="mtdSendWsp" :disabled="select.length>0?false:true" class="btn btn-sm btn-success w-100 mt-2"><i class="far fa-paper-plane"></i> Enviar mensaje</button>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-proccess-katalynas-send",
  data() {
    return {
      client: [],
      select: [],
      message:"",
      castMessagge:[],
    };
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/birthay/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.select = [];
          this.client = response.data;
        })
        .catch((errors) => {});
    },
    mtdGetCardClass(date) {
      const birthday = moment(date).year(moment().year());
      if (birthday.isSame(moment(), "day"))
        return "mr-3 text-white bg-gradient-success p-3";
      if (birthday.isBefore(moment(), "day"))
        return "mr-3 text-white bg-gradient-warning p-3";
      return "mr-3 text-white bg-gradient-info p-3";
    },
    formatDate(date) {
      return moment(date).format("DD/MM");
    },
    mtdAddNameClientWsp: function(){
      this.message += " nombre_cliente ";
    },
    mtdSendWsp: function(){
      if (!this.message.includes("nombre_cliente")) {
        Swal.fire(
          "Atención",
          "Debe agregar el nombre del cliente antes de enviar el mensaje.",
          "warning"
        );
        return;
      }

      this.castMessagge=[];
      this.select.forEach(element => {
        this.castMessagge.push({
          clientId: element.id,
          clientName: element.name,
          clientPhone: element.phone,
          message : this.message.replace("nombre_cliente",element.name)
        })
      });
      this.post({
        url:
          this.$store.getters.get__url +
          "/birthay/send/wsp",
        token: this.$store.getters.get__token,
        params:{
          wsp: this.castMessagge
        }
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.select=[];
            this.message="";
            Swal.fire({
              title: "MENSAJES ENVIADOS!!.",
              icon: "success",
            });
            this.mtdGetData();
          }
        })
        .catch((errors) => {});
    }
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  gap: 1rem;
}
.scroll-container {
  max-height: calc(100vh - 150px); /* Ajusta si tu header es más grande */
  overflow-y: auto;
  padding-right: 8px; /* Espacio para scroll */
}
</style>
